import { render } from "./driver.longhorn.io_v2.vue?vue&type=template&id=12febed8&scoped=true"
import script from "./driver.longhorn.io_v2.vue?vue&type=script&lang=js"
export * from "./driver.longhorn.io_v2.vue?vue&type=script&lang=js"

import "./driver.longhorn.io_v2.vue?vue&type=style&index=0&id=12febed8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12febed8"]])

export default __exports__